import type { CustomCellRendererProps } from "ag-grid-react";

import { DefaultCell } from "./DefaultCell.tsx";

export const TextListCell = (props: CustomCellRendererProps) => {
  return <DefaultCell {...props} />;
};
